// This file was generated by SchemaWise. To update this file, run (from the Carrot root):
// ic schema code subscriptions

import { BaseProp } from '../../base_message'
import { PropContext as ProtoPropContext } from '../../protos/instacart/events/emission/retailer_tools/v1/prop_context_pb'

export class PropContext extends BaseProp<ProtoPropContext> {
  readonly oldValueField: string | undefined
  readonly newValueField: string | undefined
  readonly contextValuesField: { [key: string]: string } | undefined

  constructor(params: {
    oldValue?: string
    newValue?: string
    contextValues?: { [key: string]: string }
  }) {
    super();
    this.oldValueField = params.oldValue
    this.newValueField = params.newValue
    this.contextValuesField = params.contextValues
  }

  toProto(): ProtoPropContext {
    return new ProtoPropContext({
      oldValue: this.oldValueField,
      newValue: this.newValueField,
      contextValues: this.contextValuesField,
    })
  }
}
